{
  "instances": {
    "httptrace": {
      "label": "Трассировка HTTP-запросов",
      "chart": {
        "avg_time": "ø задержка",
        "max_time": "максимальная задержка",
        "status_4xx": "статус 4xx",
        "status_5xx": "статус 5xx",
        "successful_requests": "успешные запросы",
        "total_requests": "всего запросов"
      },
      "content_type_response": "Тип содержимого ответа",
      "content_type_request": "Тип содержимого запроса",
      "length_request": "Длина запроса",
      "fetching_failed": "Ошибка трассировки.",
      "limit": "ограничение",
      "filter": {
        "client_errors": "ошибки на клиенте",
        "exclude_actuator": "исключить {actuator}/**",
        "server_errors": "ошибки сервера",
        "success": "успех"
      },
      "length_response": "Длина ответа",
      "method": "Метод",
      "no_traces_found": "Трассировка не найдена.",
      "status": "Статус",
      "time": "Время",
      "timestamp": "Время",
      "uri": "Путь"
    }
  }
}
